@if (indicators.length) {
  <div class="typing-indicator">
    <div class="dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <span class="label">{{ label }}</span>
  </div>
}
